import React, { useEffect, useState } from "react";
import axiosInstance from "./api/axiosInstance";
import { DEFAULT_COUNTRY_CODE, normalizeCountryCode } from "../utils/phone";

let cachedCodes = null;
let pending = null;

function loadCountryCodes() {
  if (cachedCodes) return Promise.resolve(cachedCodes);
  if (!pending) {
    pending = axiosInstance
      .get("/countries")
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : [];
        const codes = [
          ...new Set(
            rows
              .map((c) => String(c.country_code || "").trim())
              .filter((code) => /^\+?\d{1,4}$/.test(code))
              .map((code) => normalizeCountryCode(code))
          ),
        ];
        if (!codes.includes(DEFAULT_COUNTRY_CODE)) codes.unshift(DEFAULT_COUNTRY_CODE);
        cachedCodes = codes;
        return codes;
      })
      .catch(() => [DEFAULT_COUNTRY_CODE])
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Dial-code picker (+91, +1, …) for a phone input; list comes from /countries, cached per page load. */
export default function CountryCodeSelect({ value, onChange, disabled = false, ariaLabel = "Country code" }) {
  const [codes, setCodes] = useState(() => cachedCodes || [DEFAULT_COUNTRY_CODE]);
  const current = normalizeCountryCode(value || DEFAULT_COUNTRY_CODE);

  useEffect(() => {
    let cancelled = false;
    loadCountryCodes().then((list) => {
      if (!cancelled) setCodes(list);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const options = codes.includes(current) ? codes : [current, ...codes];

  return (
    <select
      className="country-code-select"
      value={current}
      onChange={(e) => onChange(normalizeCountryCode(e.target.value || DEFAULT_COUNTRY_CODE))}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {options.map((code) => (
        <option key={code} value={code}>
          {code}
        </option>
      ))}
    </select>
  );
}
